<template>
  <div>
        <div class="shenqingzhuangtai fl">
          <div class="shenqingbianhao">合同申请编号：{{contractApplyingDetail.ct__applicationNo}}</div>
          <div class="shenqingxiangqing">{{contractApplyingDetail.ct__applicationStatus|Status2CN}}</div>
          <div class="shenqingshijian">{{contractApplyingDetail.ct__applicationDate|moment('YYYY/MM/DD hh:mm')}}</div>
        </div>
    <customer-summary :data.sync="contractApplyingDetail" v-if="contractApplyingDetail.u__customerName"/>
        <div class="cb"></div>

        <el-form label-width="160px" class="xzmt">
          <el-row>
            <panel title="授信信息" border>
              <el-col :span="12">
                <el-form-item label="供应链：">{{contractApplyingDetail.ct__debtorName}}</el-form-item>
                <el-form-item label="授信类型：">{{contractApplyingDetail.ct__creditType}}</el-form-item>
                <el-form-item label="授信起始日：">{{contractApplyingDetail.ct__creditValidity1 }}</el-form-item>
                <el-form-item label="融资比例：">{{contractApplyingDetail.ct__financingRatio}} %</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="融资产品：">{{contractApplyingDetail.ct__productName}}</el-form-item>
                <el-form-item label="授信额度：">{{contractApplyingDetail.ct__lineOfCredit}} 元</el-form-item>
                <el-form-item label="授信到期日：">{{contractApplyingDetail.ct__creditValidity2}}</el-form-item>
                <el-form-item label="融资阈值：">{{contractApplyingDetail.ct__threshold}} 元</el-form-item>
              </el-col>
            </panel>
            <panel title="合同申请意向" border>
              <el-col :span="12">
                <el-form-item label="期望合同起始日：">{{contractApplyingDetail.ct__expectedContractValidity1}}</el-form-item>
                <el-form-item label="期望费率：">{{contractApplyingDetail.ct__expectedLendingFee}} {{contractApplyingDetail.ct__expectedLendingFeeType == 'Rate' ? '%' : '元'}} (收费方式：{{contractApplyingDetail.ct__expectedLendingFeeType|Status2CN}})</el-form-item>
                <el-form-item label="期望费用收取节点：">{{contractApplyingDetail.ct__expectedLendingFeePayTime}}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="期望合同到期日：">{{contractApplyingDetail.ct__expectedContractValidity2}}</el-form-item>
                <el-form-item label="期望利率：">{{contractApplyingDetail.ct__expectedInterestRate}} % ({{contractApplyingDetail.ct__expectedInterestType|Status2CN}})</el-form-item>
                <el-form-item label="期望利息收取节点：">{{contractApplyingDetail.ct__expectedInterestPayTime}}</el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="申请备注：">
                  {{contractApplyingDetail.ct__remarks}}
                </el-form-item>
              </el-col>
            </panel>
            <div class="cb"></div>
          </el-row>
        </el-form>
    <el-row>
      <el-col :span="24">
        <panel label="附件信息">
          <files-data-table :files="contractApplyingDetail.files"/>
        </panel>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import Panel from '../../components/Panel'
  import CustomerSummary from './CustomerSummary'
  import FilesUpload from '../../components/FilesUpload'
  import FilesDataTable from '../../components/FilesDataTable'

  export default {
    name: "ContractApplyingDetailComponent",
    data() {
      return {}
    },
    props: {
      contractApplyingDetail: {
        type: Object,
        default: () => {
          return {
            "i__bizlicValidity": "",
            "i__bizlicValidity1": "",
            "i__bizlicValidity2": "",
            "i__bizrepICValidity": "",
            "i__bizrepICValidity1": "",
            "i__bizrepICValidity2": ""
          }
        }
      }
    },
    components: {
      Panel,
      CustomerSummary,
      FilesUpload,
      FilesDataTable
    },
    methods: {
      downloadFile: function () {
      },
      handleClick: function () {

      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/ContractApplyingDetailComponent.vue